
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    item: {
      default: () => ({}),
      type: Object
    },
    itemType: {
      type: String,
      default: "menu",
      validator: function (value) {
        return ["menu", "cart"].includes(value);
      }
    }
  },
  computed: {
    ...mapGetters("order", ["getCartItemList"]),
    isCartItem() {
      return this.itemType === "cart";
    },
    cartItemList() {
      return this.getCartItemList({ menuId: this.item.id });
    },
    isItemExistsInCart() {
      return !!this.cartItemList.length;
    },
    getQuantityValue() {
      if (this.isItemExistsInCart) {
        return this.isCartItem
          ? this.item.quantity
          : this.cartItemList.reduce((acc, item) => (acc += item.quantity), 0);
      }
      return 0;
    },
    isUserInputRequiredForAddToCart() {
      return (
        !this.isCartItem &&
        !!(
          this.item.variants?.items?.length ||
          this.item?.item_groups?.items?.length ||
          this.item?.item_addons?.items?.length
        )
      );
    }
  },
  methods: {
    ...mapActions("order", ["updateCart"]),
    handleAddToCart() {
      if (this.isUserInputRequiredForAddToCart) {
        if (this.getQuantityValue) {
          this.$nuxt.$emit("open-added-item-customisation-dialog", this.item);
        } else {
          this.$nuxt.$emit("open-add-to-cart-dialog", this.item);
        }
      } else {
        const quantity = this.isItemExistsInCart
          ? this.getQuantityValue + 1
          : 1;
        this.updateCart({
          menuItems: [{ ...this.item, menuId: this.item.id, quantity }]
        });
      }
    },
    handleRemoveFromCart() {
      if (
        this.isUserInputRequiredForAddToCart &&
        this.cartItemList.length > 0 &&
        this.getQuantityValue > 1
      ) {
        this.$nuxt.$emit("open-added-item-customisation-dialog", this.item);
      } else {
        const quantity = this.getQuantityValue - 1;
        this.updateCart({
          menuItems: [{ ...this.item, menuId: this.item.id, quantity }]
        });
      }
    }
  }
};
